import { HTTP } from './helpers/http.js'

const signup = {
  create(data) {
    const url = '/api/v1/signup'
    return HTTP.post(url, data)
  },

  verifyOrganization(data) {
    const url = '/api/v1/signup/organization-verification'
    return HTTP.post(url, data)
  },
}

export default signup
